import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { SearchSelect } from "@/components/SearchSelect";

export default function MappingSettings({ notify }) {
  const [data, setData] = useState(null);
  const [accounts, setAccounts] = useState([]);
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    api("/account-mapping").then(setData).catch((e) => notify(e.message, "error"));
    api("/accounts").then(setAccounts).catch(() => {});
  }, []); // eslint-disable-line
  if (!data) return <div className="report-loading" data-testid="mapping-loading">Memuat pemetaan akun...</div>;
  const set = (k, v) => setData({ ...data, mapping: { ...data.mapping, [k]: v } });
  const save = async () => {
    setSaving(true);
    try {
      setData(await api("/account-mapping", { method: "PUT", body: JSON.stringify(data.mapping) }));
      notify("Pemetaan akun berhasil disimpan — jurnal otomatis berikutnya memakai akun ini.");
    } catch (e) { notify(e.message, "error"); }
    setSaving(false);
  };
  return (
    <div className="surface tax-form" data-testid="mapping-settings">
      <h3>Pemetaan Akun Default</h3>
      <p className="muted tax-hint">Akun yang dipakai otomatis saat jurnal dibentuk dari invoice penjualan dan tagihan pembelian.</p>
      <div className="tax-form-grid">
        {Object.entries(data.labels).map(([k, label]) => (
          <label key={k}>{label}
            <SearchSelect testid={`mapping-${k}`} value={data.mapping[k]} onChange={(v) => set(k, v)} placeholder="Pilih akun..."
              options={accounts.map((a) => ({ value: a.code, label: `(${a.code}) ${a.name}` }))} />
          </label>
        ))}
      </div>
      <div className="tax-form-actions">
        <button data-testid="mapping-save-button" className="primary-btn" disabled={saving} onClick={save}>{saving ? "Menyimpan..." : "Simpan Pemetaan"}</button>
      </div>
    </div>
  );
}
